/**
 * Serializes an array of strings into a consolidated readable form.
 *
 * @param path
 */
export function formatPath(path: string[]) {
  if (path.length === 0) {
    return '';
  }

  if (path.length === 1) {
    return path[0];
  }

  const [first] = path;

  let formattedPath;

  formattedPath = first.length > 10 ? first.slice(0, 10) + '...' : first;
  formattedPath += path.length > 2 ? ' ›...› ' : ' › ';
  formattedPath += path.slice(-1)[0];

  return formattedPath;
}
